module.exports = __webpack_public_path__ + "img/O2O.01fff307.png";